export const maxLength = (length: number) => (value: string): boolean =>
  value.toString().length <= length;

export const minLength = (length: number) => (value: string): boolean =>
  value.toString().length >= length;

export const isNumber = (value: string): boolean => {
  const regex = RegExp("^\\d+$");
  return regex.test(value);
};

export const isValidUKBusinessNumber = (value: string): boolean => {
  // https://www.1stformations.co.uk/blog/where-do-i-find-my-company-registration-number/
  // Always 8 characters
  // Two approved formats:
  // 1) Eight numbers: 12345678
  // 2) Two letters and six numbers: AB123456

  // We should accept leading zeros. Per this site:
  // https://www.completeformations.co.uk/companyfaqs/uk_company_setup/company_numbers.html
  // "The certificate of incorporation of a new company will show only the last seven numbers,"
  // "though the company number is actually eight digits and has a leading zero which is omitted."
  const regex = RegExp("^[0-9]{8}$|^[A-Za-z]{2}[0-9]{6}$");
  return regex.test(value);
};

export const exactLength = (len: number) => (value: string): boolean =>
  value.toString().length === len;

/* Check if valid phone number length given country format */
export const validatePhoneFromCountryFormat = (phoneFormat: string) => (
  value: string
): boolean => {
  const unformattedPhone = phoneFormat.replace(/[^.+]/g, "");
  const validLength = unformattedPhone.length;
  return exactLength(validLength)(value);
};
